(() => {
  const initialized = new WeakSet();

  function initCard(card) {
    if (!card || initialized.has(card)) return;

    const form = card.querySelector('[data-vena-product-form]');
    const variantInput = card.querySelector('[data-vena-variant]');
    const purchaseOptions = Array.from(card.querySelectorAll('[data-vena-purchase-option]'));
    const button = card.querySelector('[data-vena-purchase-button]');
    const error = card.querySelector('[data-vena-product-error]');

    if (!form || !variantInput || !purchaseOptions.length || !button || !error) return;
    initialized.add(card);

    const syncPurchaseState = () => {
      const subscriptionOption = purchaseOptions.find((option) => option.value === 'subscription');
      let selectedOption = purchaseOptions.find((option) => option.checked);

      // Subscribe & Save is intentionally the default whenever it is available.
      if (!selectedOption) {
        selectedOption = subscriptionOption || purchaseOptions[0];
        if (selectedOption) selectedOption.checked = true;
      }

      card.dataset.purchaseMode = selectedOption ? selectedOption.value : 'one-time';

      purchaseOptions.forEach((option) => {
        const choice = option.closest('.vena-purchase__choice');
        if (choice) choice.classList.toggle('is-selected', option.checked);
      });
    };

    const selectPurchaseOption = (option) => {
      if (!option || option.checked) {
        syncPurchaseState();
        return;
      }
      option.checked = true;
      option.dispatchEvent(new Event('change', { bubbles: true }));
    };

    syncPurchaseState();

    purchaseOptions.forEach((option) => {
      option.addEventListener('change', syncPurchaseState);

      const choice = option.closest('.vena-purchase__choice');
      if (!choice) return;

      choice.addEventListener('click', (event) => {
        // Keep a selling-plan selector, study link, or other nested control usable.
        if (event.target.closest('select, option, a, button, [data-vena-selling-plan]')) return;
        selectPurchaseOption(option);
      });
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      syncPurchaseState();
      error.hidden = true;
      error.textContent = '';

      const selectedOption = purchaseOptions.find((option) => option.checked);
      const variantId = Number(variantInput.value);
      const cartAddUrl = card.dataset.cartAddUrl;
      const checkoutUrl = card.dataset.checkoutUrl;

      if (!variantId || !cartAddUrl || !checkoutUrl) {
        error.textContent = 'This product is not ready for checkout yet. Please refresh and try again.';
        error.hidden = false;
        return;
      }

      const item = { id: variantId, quantity: 1 };

      if (selectedOption && selectedOption.value === 'subscription') {
        const sellingPlanInput = card.querySelector('[data-vena-selling-plan]');
        const sellingPlanId = sellingPlanInput && Number(sellingPlanInput.value);

        if (!sellingPlanId) {
          error.textContent = 'The subscription plan is not available yet. Please choose One-Time Purchase or refresh the page.';
          error.hidden = false;
          return;
        }

        item.selling_plan = sellingPlanId;
      }

      button.disabled = true;
      button.classList.add('is-loading');

      try {
        const response = await fetch(`${cartAddUrl}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              item,
              ...Array.from(card.querySelectorAll('[data-vena-addon-variant]:checked'))
                .map((input) => Number(input.value))
                .filter(Boolean)
                .map((id) => ({ id, quantity: 1 }))
            ]
          })
        });

        const responseData = await response.json();
        if (!response.ok) {
          throw new Error(responseData.description || responseData.message || 'Unable to start checkout.');
        }

        window.location.assign(checkoutUrl);
      } catch (requestError) {
        error.textContent = requestError.message || 'Unable to start checkout. Please try again.';
        error.hidden = false;
        button.disabled = false;
        button.classList.remove('is-loading');
      }
    });
  }

  function initAll(scope = document) {
    const cards = [];
    if (scope.matches && scope.matches('[data-vena-product-card]')) cards.push(scope);
    if (scope.querySelectorAll) cards.push(...scope.querySelectorAll('[data-vena-product-card]'));
    cards.forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();